import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1] as const;

const LifestyleServices = () => {
  const { t } = useLanguage();

  const services = [
    { title: t("Mobility", "Mobiliteit"), text: t("Private chauffeur services and VIP transport, aligned entirely with your schedule.", "Privéchauffeursdiensten en VIP-vervoer, volledig afgestemd op uw schema.") },
    { title: t("Dining", "Dineren"), text: t("Priority reservations at the island's most sought-after restaurants and beach clubs.", "Prioriteitsreserveringen bij de meest gewilde restaurants en beachclubs van het eiland.") },
    { title: t("Nights", "Uitgaan"), text: t("Guest list access and VIP tables at Ibiza's leading nightlife venues.", "Gastenlijst toegang en VIP-tafels bij de toonaangevende uitgaansgelegenheden van Ibiza.") },
    { title: "Wellness", text: t("In-villa treatments and private wellness experiences.", "In-villa behandelingen en privé wellness-ervaringen.") },
    { title: t("Private Dining", "Privé Dineren"), text: t("Personal chefs and tailored dining within your residence.", "Persoonlijke chefs en op maat gemaakt dineren in uw residentie.") },
    { title: t("Assistance", "Assistentie"), text: t("Discreet support, always available.", "Discrete ondersteuning, altijd beschikbaar.") },
    { title: "Bespoke", text: t("Any request, handled with precision.", "Elk verzoek, met precisie afgehandeld.") },
  ];

  return (
    <section className="py-28 md:py-40 bg-background">
      <div className="container-luxury max-w-5xl">
        <motion.div
          className="text-center mb-20 md:mb-28"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, ease }}
        >
          <span className="font-label text-bronze text-[10px] tracking-[0.35em] block mb-8">{t("Services", "Diensten")}</span>
          <h2 className="font-display text-3xl md:text-5xl text-foreground tracking-wide uppercase">
            {t("What We Arrange", "Wat Wij Regelen")}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-16 gap-x-12 md:gap-x-16">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, delay: i * 0.06, ease }}
            >
              <span className="font-display text-4xl text-foreground/6 block mb-3">0{i + 1}</span>
              <h3 className="font-display-medium text-sm text-foreground tracking-[0.2em] uppercase mb-4">
                {s.title}
              </h3>
              <div className="w-6 h-px bg-bronze/40 mb-4" />
              <p className="font-body text-muted-foreground text-sm leading-[2]">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifestyleServices;
